import { OverrideToken } from "antd/es/theme/interface";
import styles from "rivals/styles/exports.module.scss";

export const anchorComponentToken: Partial<OverrideToken["Anchor"]> = {
  colorLink: styles.callToActionBlue,
  linkDecoration: "underline",
  linkHoverDecoration: "underline"
};
